/* eslint-disable */
import { WebApi } from "@/services/WebApi"

const state = () => ({
    petImages: [],
    loadingPetImages: false,
    retryPetImages: false
})

const mutations = {
    setPetImages(state, petImages) {
        state.petImages = petImages;
    },
    setLoading(state, loading) {
        state.loadingPetImages = !!loading;
    },
    setRetry(state, retry) {
        state.retryPetImages = !!retry;
    }
}

const actions = {
    getPetImagesBySiteId({ commit }, siteId) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            WebApi.get('Portal/'+ siteId +'/PetImage')
                .then(response => {
                    commit('setPetImages', response.data);
                    resolve(response);
                })
                .catch(error => {
                    commit('setRetry', true);
                    reject(error);
                })
                .finally (() => {
                    commit('setLoading', false);
                });
        });
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}